import { Pipe, PipeTransform } from '@angular/core';

import { AlternateTranslationService } from '../services/alternate-translation.service';

@Pipe({
  name: 'alternateTranslation',
  standalone: false,
})
export class AlternateTranslationPipe implements PipeTransform {
  constructor(private alternateService: AlternateTranslationService) {}
  transform(text: string): string {
    return this.alternateService.alternate(text);
  }
}
